import { p as pako } from './pako.esm-ef1fc3f4.mjs';

class GZip {
    constructor(level = 1) {
        if (level < 0 || level > 9) {
            throw new Error('Invalid gzip compression level, it should be between 0 and 9');
        }
        this.level = level;
    }
    static fromConfig({ level }) {
        return new GZip(level);
    }
    encode(data) {
        const gzipped = pako.gzip(data, { level: this.level });
        return gzipped;
    }
    decode(data, out) {
        const uncompressed = pako.ungzip(data);
        if (out !== undefined) {
            out.set(uncompressed);
            return out;
        }
        return uncompressed;
    }
}
GZip.codecId = 'gzip';

export default GZip;
